<template>
<div>
    <div v-if="formulario == 1">
      <main class="d-flex justify-content-center inicio-home"> 
        <form @submit.prevent="submit1">
          <div class="container">
                <div class="row">

                    <div class="col-md-12 calculadora p-5re" id="">
                      <div class="text-center">
                        <img class="" src="@/assets/img/t-o.png" alt="">
                        <h2 class="t-tiempo">{{tiempo.minutos}}:{{tiempo.segundos}}</h2>
                      </div>
                        <br>
                           <h5 class="text-center">
                              {{detalleTransaccion1}}<br>
                              {{detalleTransaccion2}}<br>
                              {{detalleTransaccion3}}<br>
                              {{detalleTransaccion4}}</h5>
                             <br>
                        <div >
                          <button type="button"  class="w-100 btn btn-sm btn-iniciar-sesion" @click="listarCuentaKallpa">CONSULTA NUESTRAS CUENTAS BANCARIAS <i class="fas fa-download"></i></button>
                        </div> 
                        <br>

                            <div class="col-md-12">
                                <label for="bancoEnviar" class="form-label s-b">¿A qué banco nos enviarás el dinero? </label>
                                <select class="form-select" aria-label="Default select example" id="bancoEnviar" v-model="registerForm.IdCuentaKallpa" required>
                                  <option v-for="(linea,index) in cuentasKallpa" :key="index" :value="linea.IdBancosKallpa" v-text="linea.DescripcionBancoCuenta" ></option>
                                </select>
                            </div> <br>
                            <div class="col-md-12">
                                  <label for="" class="form-label s-b">¿En qué banco deseas recibir tu dinero?</label>
                                  <select class="form-select" v-model="registerForm.IdCuentaBancoCliente" required>
                                    <option v-for="(linea,index) in cuentasClient" :key="index" :value="linea.IdBancoCliente" v-text="linea.NombreCuenta"></option>
                                  </select>
                            </div>
                              <br>
                              <div class="col-md-12 d-flex justify-content-center"><h5>¿Ya transferiste?</h5></div>
                              <br>
                              <div class="col-md-12">
                                <button type="button" style="float: left;"  class="btn btn-light" @click="listarCuentaKallpa">No , Nuestras Cuentas <i class="fas fa-download"></i></button>
                                <button type="submit" style="float: right;" class="btn btn-light">Si, continuar <i class="fas fa-arrow-right"></i></button>
                              </div>
                              <div style="clear: both;"></div>
                              <br>
                              <!--calculadora-->
                    </div>
 
                </div>
            </div>
          </form>
      </main>
    </div>

  <div v-if="formulario == 2">
  <main class="d-flex justify-content-center inicio-home">   
    <form @submit.prevent="submit">
            <div class="container">
                <div class="row">

                    <div class="col-md-12 calculadora p-5re" id="">
                        <div class="text-center">
                        <img class="" src="@/assets/img/t-o.png" alt="">
                        <h2 class="t-tiempo">0{{tiempo.minutos}}:{{tiempo.segundos}}</h2>
                        </div>
                          <div class="col-md-12">
                            <label for="" class="form-label">Número de la operación</label>
                            <input type="text" class="form-control" id="" placeholder="" v-model="registerForm.NumeroOperacion" > 
                          </div> <br>
                          
                        <div class="file-upload">
                            <button class="file-upload-btn" type="button" onclick="$('.file-upload-input').trigger( 'click' )">Añadir imagen</button>
                          
                            <div class="image-upload-wrap" v-if="registerForm.ComprobanteArchivoBase64=='' || registerForm.ComprobanteArchivoBase64=='data:,'">
                              
                              <input class="file-upload-input" type='file' @change="readURL" accept="image/*,.pdf" :key="fileInputKey" required />
                              <div class="drag-text">
                                <h3>ARRASTRA Y SUELTA LA IMAGEN DEL COMPROBANTE DE PAGO</h3>
                              </div>
                            </div>
                            <div class="file-upload-content">
                              <img class="file-upload-image" id="imageComprobante" :src="registerForm.ComprobanteArchivoBase64" alt="" />
                              <div class="image-title-wrap">
                                <button v-if="mostrarImgC==true" type="button" @click="removeUpload" class="remove-image">Eliminar <span class="image-title">Uploaded Image</span></button>
                              </div>
                            </div>
                          </div> <br>
                        <div class=""><button class="w-100 btn btn-lg btn btn-registro "  type="submit">Enviar comprobante</button></div> <br> 
                        <div class="col-md-12 d-flex justify-content-between">
                           <button type="button" class="btn btn-light" @click="formulario-=1"><i class="fas fa-arrow-left"></i> Volver </button> 
                        </div>
                    </div> <!--calculadora-->  

                </div>
            </div>  
      </form>
      </main>
    </div>

    <div class="modal fade" id="conf-operacion" tabindex="-1" aria-labelledby="conf-operacionLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center"><img src="@/assets/img/billetera.png" alt=""></div> 
            <br>
            <h3 class="titulo-registro text-center">Acabas de realizar 
              <br>la siguiente operación:</h3> <br>
             <p class="text-center" v-text="detalleVenta"> </p>
             <p class="text-center" style="margin-top: -3%;" v-text="detalleVenta2"> </p>
             <p class="text-center" style="margin-top: -3%;">A un tipo de cambio de {{valorCambio}}  </p> 
          </div>      
          <div class="modal-footer">
            <button type="button" class="btn btn-registro" data-bs-dismiss="modal" @click="submit2">Continuar</button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal" tabindex="-1" id="modalTiempoAcabado" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
           <div class="m">
                 <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close" @click="$router.push('/user-inicio-usuario').catch(err => {})"></button>
            </div>
          <div class="modal-body">
            <p>Tu tiempo ha terminado. Por favor intenta nuevamente.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-registro" data-bs-dismiss="modal" @click="$router.push('/user-inicio-usuario').catch(err => {})">Aceptar</button>
          </div>
        </div>
      </div>
    </div>

      <!-- Modal cuentas kallpa-->
    <div class="modal fade" id="cuenta-banco-kallpa" tabindex="-1" aria-labelledby="cuenta-banco-kallpaLabel" aria-hidden="true">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="m">
                <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
                <div class="modal-body">
                  <h2 class="titulo-registro text-center">Cuentas bancarias <br> de Kallpa Securities S.A.B.</h2>
                  <div class="d-flex justify-content-center">
                  <a class="btn btn-sm btn-iniciar-sesion" :href="urlCuentasBancarias" target="_blank">Archivo de cuentas bancarias <i class="fas fa-download"></i></a>
                </div>
                    <br>
                    <div class="d-flex justify-content-between n-cuenta" v-for="(linea,index) in cuentasKallpa" :key="index">
                        <div class="col-md-9 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1"><img :src="linea.Url_ImagenBanco" alt="" height="20"></li>
                                <li class="">{{descMo}}</li>
                                <li>Nro Cuenta: {{linea.NumeroCuenta}}</li>
                                <li>CCI: {{linea.CCI}}</li>
                            </ul>
                        </div>
                        <div class="col-md-3 d-flex justify-content-end">
                          <ul class="list-ope">
                            <li><br></li>
                            <li><br></li>
                            <li><a href="" class="d-flex align-items-center" @click.prevent="copiar(linea.NumeroCuenta)">Copiar</a></li>
                            <li><a href="" class="d-flex align-items-center" @click.prevent="copiar(linea.CCI)">Copiar</a></li>
                          </ul>
                            
                        </div>
                    </div>
                    <p class="text-center">RUC: 20492942121</p>
                </div>
               
            </div>
            </div>
    </div><!-- Modal cuentas kallpa -->

</div>
</template>

<script>

import auth from '@/services/auth'
import helpers from '@/services/helpers'
import Vue from 'vue';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });

  export default {
    name: "Operacion",
    data() {
      return {
        fileInputKey: 0,
        formulario:1,
        tipoCambio:localStorage.getItem("tipoCambio"),
        valorCambio:"",
        descMo:"",
        cambioCompra: this.$store.getters.getTipoCambio('compra'),
        cambioVenta: this.$store.getters.getTipoCambio('venta'),
        valorEnviar:numeral(localStorage.getItem("valorEnviar")).format('0,0.00'),
        valorRecibir:numeral(localStorage.getItem("valorRecibir")).format('0,0.00'),
        detalleTransaccion1:"",
        detalleTransaccion2:"",
        detalleTransaccion3:"",
        detalleTransaccion4:"",
        detalleVenta:"",
        detalleVenta2:"",
        selectBanc:[],
        cuentasClient:[],
        cuentasKallpa:[],
        disabled: true,
        tituloMensaje:"",
        contenidoMensaje:"",
        comprobante:"",
        urlCuentasBancarias: "#",
        registerForm: {
          IdTipoOperacion:"1",
          Fx_TipoCambioActual:"",
          USD_MontoDolares:"",
          PEN_MontoSoles:"",
          IdCuentaBancoCliente:"",
          IdCuentaKallpa:"",
          TCT_Compra:"",
          TCT_Venta:"",
          NumeroOperacion:"",
          ComprobanteArchivoBase64:"",
          IdAplicacion:"3",
          IdCupon:localStorage.getItem("IdCupon"),
          Cupon: false
        },
        MontoCupon:numeral(localStorage.getItem("MontoCupon")).format('0,0.00'),
        MensajeCupon:localStorage.getItem("MensajeCupon"),
        registerCupon: {
          IdCupon:localStorage.getItem("IdCupon"),
          IdCliente:"",
          IdUsuario:"",
          descuento:numeral(localStorage.getItem("DescuentoCupon")).format('0,0.0000')
        },
        mostrarImgC:false,
        tiempo:{
          function: null,
          total: 5*60,
          minutos: 0,
          segundos: 0,
        }

      };
    },

  beforeCreate() {
    this.tipoCambio=localStorage.getItem("tipoCambio");
    if(this.tipoCambio==1){
      auth.listBankKallpa(this,"TIMO0002").then(response => {
        this.cuentasKallpa=response.filter(e=>e.TipoMoneda=="TIMO0002");
        });
      auth.listBankClient(this,"TIMO0001").then(response => {
      this.cuentasClient=response.filter(e=>e.Moneda=="TIMO0001");
      });
    }
    else{
      auth.listBankKallpa(this,"TIMO0001").then(response => {
        this.cuentasKallpa=response.filter(e=>e.TipoMoneda=="TIMO0001");
        });
      auth.listBankClient(this,"TIMO0002").then(response => {
      this.cuentasClient=response.filter(e=>e.Moneda=="TIMO0002");
      });
    }
    
    $('.image-upload-wrap').bind('dragover', function () {
      $('.image-upload-wrap').addClass('image-dropping');
    });
    $('.image-upload-wrap').bind('dragleave', function () {
        $('.image-upload-wrap').removeClass('image-dropping');
    });
    auth.listParameters().then(response => {
      this.urlCuentasBancarias = response.ParametrosGenerales.find(e=>e.Id=="MENS0005").DetalleParametroValor;
    });
  },
  mounted(){
    if(this.tipoCambio==1){
      this.detalleVenta="Vendiste a Kallpa Cambios "; 
      this.detalleVenta2=this.valorEnviar +" dólares"; 
      this.valorCambio=this.$store.getters.getTipoCambio('compra');
      this.detalleTransaccion1="Vendiste "+this.valorEnviar+" dólares";
      if (this.MensajeCupon=="OK"){
        this.detalleTransaccion2="AL TIPO DE CAMBIO "+ (parseFloat(this.valorCambio) + parseFloat(this.registerCupon.descuento)).toFixed(4);
        this.detalleTransaccion4="Ahora recibirás "+this.MontoCupon+" soles";
      }else{
        this.detalleTransaccion2="AL TIPO DE CAMBIO "+this.valorCambio;
        this.detalleTransaccion4="Recibirás "+this.valorRecibir+" soles";
      }      
      this.detalleTransaccion3="Debes depositar "+this.valorEnviar+" dólares a Kallpa Cambios";
      this.descMo="DÓLARES";
    }
    else{
      this.detalleVenta="Compraste a Kallpa Cambios ";
      //this.detalleVenta2=this.valorRecibir +" dólares"; 
      this.valorCambio=this.$store.getters.getTipoCambio('venta');
      this.detalleTransaccion1="Compraste "+this.valorRecibir+" dólares";
      if (this.MensajeCupon=="OK"){
        this.detalleTransaccion2="AL TIPO DE CAMBIO "+(parseFloat(this.valorCambio) + parseFloat(this.registerCupon.descuento)).toFixed(4);
        this.detalleTransaccion4="Ahora recibirás "+this.MontoCupon+" dólares";
        this.detalleVenta2=this.MontoCupon +" dólares"; 
      }else{
        this.detalleTransaccion2="AL TIPO DE CAMBIO "+this.valorCambio;
        this.detalleTransaccion4="Recibirás "+this.valorRecibir+" dólares";
        this.detalleVenta2=this.valorRecibir +" dólares"; 
      }
      this.detalleTransaccion3="Debes depositar "+this.valorEnviar+" soles a Kallpa Cambios";
      
      this.descMo="SOLES";
    }
    
    this.inciaContador();
  
  },
 methods:{
    submit1(e) {
      this.formulario +=1;
    },
    submit2() {
      this.$router.push("/user-operaciones-verificando").catch(err => {});
    },
    async submit(e) {

      if(this.registerForm.ComprobanteArchivoBase64!="data:," || this.registerForm.NumeroOperacion!=""){
        
          this.registerForm.TCT_Compra=this.$store.getters.getTipoCambio('compra');
          this.registerForm.TCT_Venta=this.$store.getters.getTipoCambio('venta');

          if(this.tipoCambio=="1"){
            this.registerForm.IdTipoOperacion=2;
            //this.registerForm.Fx_TipoCambioActual=this.$store.getters.getTipoCambio('compra');
            this.registerForm.USD_MontoDolares=numeral(this.valorEnviar).value();
            
            if (this.MensajeCupon=="OK"){
              this.registerForm.PEN_MontoSoles=numeral(this.MontoCupon).value();
              this.registerForm.Cupon=true;
              this.registerForm.Fx_TipoCambioActual=(parseFloat(this.valorCambio) + parseFloat(this.registerCupon.descuento)).toFixed(4);
              this.valorCambio=(parseFloat(this.valorCambio) + parseFloat(this.registerCupon.descuento)).toFixed(4);
            } else {
              this.registerForm.PEN_MontoSoles=numeral(this.valorRecibir).value();
              this.registerForm.Fx_TipoCambioActual=this.$store.getters.getTipoCambio('compra');
              this.valorCambio=this.$store.getters.getTipoCambio('compra');
            }

          }else{
            
            this.registerForm.IdTipoOperacion=1;
            //this.registerForm.Fx_TipoCambioActual=this.$store.getters.getTipoCambio('venta');
            this.registerForm.PEN_MontoSoles=numeral(this.valorEnviar).value();
            
            if (this.MensajeCupon=="OK"){
              this.registerForm.USD_MontoDolares=numeral(this.MontoCupon).value();
              this.registerForm.Cupon=true;
              this.registerForm.Fx_TipoCambioActual=(parseFloat(this.valorCambio) - parseFloat(this.registerCupon.descuento)).toFixed(4);
              this.valorCambio=(parseFloat(this.valorCambio) - parseFloat(this.registerCupon.descuento)).toFixed(4);
            }else{
               this.registerForm.USD_MontoDolares=numeral(this.valorRecibir).value();
               this.registerForm.Fx_TipoCambioActual=this.$store.getters.getTipoCambio('venta');
               this.valorCambio=this.$store.getters.getTipoCambio('venta');
            }
           
          }
          clearInterval(this.tiempo.function);
          localStorage.setItem("numeroOperacion",this.registerForm.NumeroOperacion);
          //console.log(this.registerForm);
          $('#conf-operacion').modal({backdrop: 'static', keyboard: false});
          $('#conf-operacion').modal('show');
          //this.guardar();

            if (await auth.registerOperation(this)){}
            if (this.MensajeCupon=="OK"){
              if (await auth.registerClientCupon(this)){} 
            }

          helpers.habilitarBoton(this, 4);

        }
      else{
        toastr["error"]('Ingrese el Número de Operación o suba su Comprobante de Pago');
      }
      
    },
    listarCuentaKallpa(){
      $('#cuenta-banco-kallpa').modal('show');
    },
    copiar(valor){
        valor=valor.replace("-", "");
            valor=valor.replace("-", "");
                valor=valor.replace("-", "");
        

        var textarea = document.createElement('textarea');
                textarea.textContent = valor; //con esto es cambia la url por el valor que deseas copiar
                document.body.appendChild(textarea);

                var selection = document.getSelection();
                var range = document.createRange();
                //  range.selectNodeContents(textarea);
                range.selectNode(textarea);
                selection.removeAllRanges();
                selection.addRange(range);

                document.execCommand('copy');
                
                selection.removeAllRanges();

                document.body.removeChild(textarea);
                toastr["success"]('Se copió al portapapeles');
    },
    readURL(ev) {
      var input=ev.target;
        if (input.files && input.files[0]) {
          if (input.files[0].type =="application/pdf" || input.files[0].type =="image/png"|| input.files[0].type =="image/jpg" || input.files[0].type =="image/gif" || input.files[0].type =="image/bmp" || input.files[0].type =="image/jpeg") {
          var reader = new FileReader();
          //var img=await this.loadImage();
         this.loadImage(reader,input).then(result=>{
           this.registerForm.ComprobanteArchivoBase64=result;
           })
          reader.readAsDataURL(input.files[0]);
          this.mostrarImgC=true;
          } else {
                this.fileInputKey++;
                $('.file-upload-content').hide();
                $('.image-upload-wrap').show();
                this.mostrarImgC=false;
                this.registerForm.ComprobanteArchivoBase64="";
                toastr["error"]('Formato no valido');
          }
        } else {
          removeUpload();
        }
    },
    loadImage(reader,input){
          return new Promise((resolve)=>{
            reader.onload =   function(e){
             $('.image-upload-wrap').hide();
             $('.file-upload-image').attr('src', e.target.result);
             $('.file-upload-content').show();

             $('.image-title').html(input.files[0].name);
            resolve(e.target.result);
            }

          })
           
        },
    getBase64Image(img) {

    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL();
    return dataURL;
    
  },
  convertirbase64(){
    var base64 = this.getBase64Image(document.getElementById("imageComprobante"));//el id de l aimagena ocnvertia base64;
  },

    removeUpload() {
    //$('.file-upload-input').replaceWith($('.file-upload-input').clone());
    //this.fileInputKey++;
    $('.file-upload-content').hide();
    $('.image-upload-wrap').show();
    this.mostrarImgC=false;
    this.registerForm.ComprobanteArchivoBase64="";
    },
    inciaContador(){
      
      let tiempo = this.tiempo;
      this.tiempo.function = setInterval(function(){
          tiempo.minutos = Math.floor(tiempo.total / 60);
          tiempo.segundos = (tiempo.total % 60)
          if(tiempo.segundos<10){
            tiempo.segundos="0"+tiempo.segundos;
          }
          tiempo.total--;
          //condicion si llega a 0;
          // console.log(tiempo.total);
          if(tiempo.total < 0) 
            {
              clearInterval(tiempo.function);
              $('#modalTiempoAcabado').modal({backdrop: 'static', keyboard: false});
              $('#modalTiempoAcabado').modal('show');
            }
      }, 1000);
      
      },


      },
    };
    </script>


// WEBPACK FOOTER //
// src/components/user/Operacion.vue